// extracted by mini-css-extract-plugin
export default {"root":"_1m1gB1HrE2yoAnkWa2wBJg==","userInfo":"DjdnCskNY2R1aC-9nBktgg==","textPrimary":"VBHfMTs7gagUK866THTfHg==","textSecondary":"hom3Lojn16+5E11vVEy4Tw=="};